import React, { useState } from 'react';
import { DateRangePicker } from '../../analytics/components/DateRangePicker';
// Lightweight wrapper that supplies the required value/onChange props to the
// shared analytics DateRangePicker, so outlet pages can drop it in without
// each managing their own date state.
export function OutletDateRange() {
  const today = new Date();
  const start = new Date();
  start.setDate(today.getDate() - 30);
  const [range, setRange] = useState({
    start,
    end: today
  });
  return <DateRangePicker value={range} onChange={setRange} data-id="element-7497" />;
}